<template>
  <div class="company-size-selector">
    <ue-select
      :options="sizeGroupings"
      @input="selected"
      v-model="sizeGroup"
      placeholder="Select Size"
    />
  </div>
</template>
<script>
export default {
  props: ['input', 'value'],
  data() {
    return {
      size: null,
      sizeGroup: {},
      sizeGroupings: [
        { code: 'small_business', label: 'Small Business (1-50 employees)' },
        { code: 'medium_enterprise', label: 'Medium Enterprise (51-1000 employees)' },
        { code: 'large_enterprise', label: 'Large Enterprise (1001+ employees)' },
        { code: 'fortune_500', label: 'Fortune 500' },
      ],
    }
  },
  mounted() {
    this.sizeGroup = this.sizeGroupings.filter((s) => s.code == this.value)
  },
  methods: {
    selected() {
      this.$emit('input', this.sizeGroup.code)
    },
  },
}
</script>
